import app from "flarum/forum/app";
import { extend } from "flarum/common/extend";
import PageStructure from "flarum/forum/components/PageStructure";
import IndexSidebar from "flarum/forum/components/IndexSidebar";
import LinkButton from "flarum/common/components/LinkButton";
import FactList from "../common/components/FactList";
import FactPage from "./components/FactPage";
import FactBrowsePage from "./components/FactBrowsePage";
import FactDeletedNotification from "./components/FactDeletedNotification";
import { t } from "../common/api";
app.initializers.add("xgay-fact", () => {
  app.notificationComponents.xgayFactDeleted = FactDeletedNotification;
  app.routes.xgayFact = {
    path: "/facts/",
    component: FactBrowsePage
  };
  app.routes.xgayFactManage = {
    path: "/facts/manage",
    component: FactPage
  };
  app.routes.xgayFactShow = {
    path: "/fact/:id",
    component: FactPage
  };
  app.routes.xgayFactLegacy = {
    path: "/facts/:id",
    component: FactPage
  };
  extend(PageStructure.prototype, "mainItems", function (items) {
    if (app.current.matches(FactPage) || app.current.matches(FactBrowsePage) || app.current.matches("ext:fof/pages/forum/components/PagePage")) return;
    items.add("xgay-facts", m("div", {
      className: "container FactStrip"
    }, m(FactList, {
      compact: true,
      open: story => m.route.set(app.route("xgayFact") + "#" + story.id)
    }), m(LinkButton, {
      href: app.route("xgayFactManage"),
      className: "Button Button--text"
    }, t("manage"))), items.has("xgay-banner") ? items.getPriority("xgay-banner") - 1 : 149);
  });
  extend(IndexSidebar.prototype, "navItems", items => {
    items.add("xgay-facts", LinkButton.component({
      href: app.route("xgayFact"),
      icon: "fas fa-bolt"
    }, t("stories")), 20);
  });
}, -110);